import { render, staticRenderFns } from "./ArrendamientoConcepto.vue?vue&type=template&id=48c387cc&"
import script from "./ArrendamientoConcepto.vue?vue&type=script&lang=js&"
export * from "./ArrendamientoConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports